import styled from "@emotion/styled";

import { fontRoboto, theme } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;

  ${theme.breakpoints.between("tablet", "desktop")} {
    flex-wrap: wrap;
    gap: 12px;
  }
`;

export const TitleAndDetailsContainer = styled.div`
  flex: 1 0 0;

  min-inline-size: 0;
  padding-inline-end: 20px;

  ${theme.breakpoints.between("tablet", "desktop")} {
    flex-basis: 100%;

    padding-inline-end: 0;
  }
`;

export const Title = styled.div`
  margin-block-end: 8px;

  font-weight: 700;
  font-size: 14px;
`;

export const SubscribeDetails = styled.div`
  font-weight: 400;
  font-size: 14px;
`;

export const ButtonContainer = styled.div`
  flex-shrink: 0;

  button {
    padding-block: 10px !important;
    padding-inline: 16px !important;

    font-family: ${fontRoboto};
  }
`;
